import type { CSSProperties } from 'react';

import { type Card, type Label, labelBackground } from '@/entities/board';

/** The colors of a card's labels, in the card's OWN label order (labels that are gone are skipped). */
export function labelColorsOf(card: Card, labels: readonly Label[]): string[] {
  return card.label_ids.flatMap((id) => labels.find((label) => label.id === id)?.color ?? []);
}

export interface ItemFill {
  /** `none` = the standard styling; `solid` = one label; `segments` = several (hard-edged). */
  kind: 'none' | 'solid' | 'segments';
  /** Solid color (kind `solid`). */
  color?: string;
  /** `linear-gradient(135deg, ...)` with sharp segments (kind `segments`). */
  gradient?: string;
}

export function itemFill(colors: readonly string[]): ItemFill {
  const background = labelBackground(colors);
  if (!background) return { kind: 'none' };
  return background.kind === 'solid'
    ? { kind: 'solid', color: background.color }
    : { kind: 'segments', gradient: background.css };
}

/** The colored bar of a calendar item: its labels, else the board's color. */
export function barStyle(fill: ItemFill, boardColor: string): CSSProperties {
  if (fill.kind === 'solid') return { background: fill.color };
  if (fill.kind === 'segments') return { backgroundImage: fill.gradient };
  return { background: boardColor };
}
